import { ChangeDetectorRef, Component, Input, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { LayerService } from '../../../services/layer.service';
import { ITableColumnSettings } from '../../utilityComponents/table/table-types';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-additional-information-ng',
    styleUrls: ['../../sharedStyles/base.scss'],
    templateUrl: './additional-information.component.html'
})
export class DataTableAdditionalInformationComponent {
    private _feature: any;

    childTableColumnSettings: ITableColumnSettings[] = [];
    childTableData: any[] = null;
    childTableSettings: ITableColumnSettings[] = [{ dataType: 'string', propertyName: 'title' }];
    geoSnapTableId: number = 161;
    loading: boolean = false;

    @Input()
    public layerId: number;

    @Input()
    public childTables: any[];

    @Input()
    set feature(newValue: any) {
        this._feature = newValue;
        this.refreshGridData();
    }
    get feature(): any {
        return this._feature;
    }

    constructor(
        _vcr: ViewContainerRef,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly layerService: LayerService
    ) {}

    async refreshGridData() {
        this.toggleLoading(true);
        this.childTableData = await this.loadChildTableData();
        this.toggleLoading(false);
    }

    public hasChildTableRecords = (dataItem: any): boolean => {
        return dataItem.data.length > 0;
    }

    async loadChildTableData(): Promise<any> {
        const childTableFeaturePromises = [];
        for (const childTable of this.childTables) {
            let childParentKeyColumnName;
            if (childTable.tableId === this.geoSnapTableId) {
                childParentKeyColumnName = 'objectid';
            } else {
                childParentKeyColumnName = childTable.childParentKeyColumnName.toLowerCase();
            }

            const columnId = this.feature[childParentKeyColumnName];

            const childTableFeaturePromise = this.layerService.getLayerChildTable(
                this.layerId,
                childTable.tableId,
                `id name columns { name } data(filter: "${childParentKeyColumnName} = ${columnId}", fieldNames: ["*"])`
            );

            childTableFeaturePromises.push(childTableFeaturePromise);
        }
        const allChildTableDataForFeature = await Promise.all(
            childTableFeaturePromises
        );

        const childTableDictionaryArray = new Array();
        for (const record of allChildTableDataForFeature) {
            const childTable: IChildTableData = {} as IChildTableData;
            childTable.name = record[0].childTables[0].name;
            childTable.columns = record[0].childTables[0].columns;
            const dataArrayArray =
                record[0].childTables[0].data.length > 0
                    ? record[0].childTables[0].data
                    : [];
            const dataDictionaryArray = [];
            if (dataArrayArray.length > 0) {
                for (const dataArray of dataArrayArray) {
                    const dataDictionary = {};
                    for (let i = 0; i < childTable.columns.length; i++) {
                        dataDictionary[childTable.columns[i].name] =
                            dataArray[i];
                    }
                    dataDictionaryArray.push(dataDictionary);
                }
            }
            childTable.data = dataDictionaryArray;
            childTable.title = `${childTable.name} (${childTable.data.length})`;
            childTable.hasRowDetails = childTable.data.length > 0;
            childTableDictionaryArray.push(childTable);
        }

        return childTableDictionaryArray;
    }

    getChildTableColumnSettings(columns: any[]) {
        const childTableColumnSettings: ITableColumnSettings[] = [];

        columns.forEach(column =>
            childTableColumnSettings.push({ dataType: 'string', propertyName: column.name, title: column.name })
        );

        return childTableColumnSettings;
    }

    onExpandCollapseRow(event) {
        this.childTableColumnSettings = this.getChildTableColumnSettings(event.data.columns);
    }

    private toggleLoading(isLoading: boolean) {
        this.loading = isLoading;
        this.changeDetectorRef.detectChanges();
    }
}

interface IChildTableData {
    name: string;
    columns: any[];
    data: any[];
    title: string;
    hasRowDetails: boolean;
}
